import { HostResponse, HostStatus } from "__generated__/graphql";
import { formatted } from "common/util/date";
import { hostStatusOptions, InputHostStatus } from "constant/host";

export const getHostStatus = (status: HostStatus): string =>
  hostStatusOptions.find((option) => option.value === status)?.label ?? InputHostStatus.ACTIVE;

export const getHostRecord = (host: HostResponse | undefined) => {
  if (!host) return host;

  const { hostIsNumber, startDate, status, title, isNaikin } = host;

  return {
    ...host,
    title: title?.name,
    hostIsNumber: hostIsNumber ? "○" : "×",
    // ex: "2019-12-03T09:54:33Z"
    startDate: formatted(startDate as string | null),
    status: getHostStatus(status),
    isNaikin: isNaikin ? "○" : "×",
  };
};

export const getHostByTitleRecord = (host: HostResponse | undefined) => {
  if (!host) return host;

  const { status, title, store } = host;

  return {
    ...host,
    title: title?.name,
    status: getHostStatus(status),
    storeName: store?.name,
  };
};
